/**
 * Finds indices of items that have duplicate values (case-insensitive, trimmed).
 * Skips empty/blank values — two items with empty strings are NOT considered duplicates.
 *
 * @param values - Pre-normalized (trimmed, lowercased) string values to compare
 * @returns Set of indices that have at least one duplicate
 */
export function findDuplicateIndices(values: string[]): Set<number> {
  const duplicateIndices = new Set<number>();

  for (let i = 0; i < values.length; i++) {
    if (!values[i]) continue;
    for (let j = i + 1; j < values.length; j++) {
      if (values[i] === values[j]) {
        duplicateIndices.add(i);
        duplicateIndices.add(j);
      }
    }
  }

  return duplicateIndices;
}
